/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-12-10                                                        *
 ******************************************************************************/

export default {
    props: {
        label:{
            type:String,
            required:true
        },
        labelColsMd:{
            type:String,
            default:'4'
        },
        labelColsLg:{
            type:String,
            default:'4'
        },
        labelColsXl:{
            type:String,
            default:'3'
        },
        item:{
            type:Object,
            required:true
        },
        field:{
            type:String,
            required:true
        },
        disabled:{
            type:Boolean,
            default:false
        },
        required:{
            type:Boolean,
            default:false
        },
    }
}
